import React from 'react';
import PropTypes from 'prop-types';
import TransactionCommonModal from '../../common/TransactionCommonModal';
import TransferForm from './TransferForm';
import TransferConfirmation from './TransferConfirmation';

const TransferModal = ({
    formData,
    fieldError,
    isLoading,
    isConfirmModal,
    isOpen,
    onClose,
    onBack,
    handleConfirmationModal,
    onClickCall,
    handleAmountChange,
    handleEmailChange,
    handleReferenceChange,
    handleCurrencyChange,
    balancesCurrencies,
    selectedMerchant,
    isFormValid,
    receiverDetails,
}) => {
    return (
        <TransactionCommonModal
            open={isOpen}
            onClose={onClose}
            onBack={onBack}
            heading={
                !isConfirmModal
                    ? `TRANSFER ${selectedMerchant && Object.keys(selectedMerchant).length > 0 ? 'To MERCHANT' : ''}`
                    : 'TRANSFER CONFIRMATION'
            }
            bottomButtonText={
                !isConfirmModal ? 'CONTINUE' : isLoading ? 'Processing...' : 'TRANSFER'
            }
            onBottomButtonClick={!isConfirmModal ? handleConfirmationModal : onClickCall}
            showBackButton={isConfirmModal}
            showCloseIcon={isConfirmModal ? false : true}
            loading={isLoading}
            disabled={isLoading || (!isConfirmModal && !isFormValid)}>
            {!isConfirmModal ? (
                <TransferForm
                    formData={formData}
                    fieldError={fieldError}
                    handleAmountChange={handleAmountChange}
                    handleEmailChange={handleEmailChange}
                    handleReferenceChange={handleReferenceChange}
                    handleCurrencyChange={handleCurrencyChange}
                    balancesCurrencies={balancesCurrencies}
                    selectedMerchant={selectedMerchant}
                    dataE2eModal="transfer-modal"
                />
            ) : (
                <TransferConfirmation
                    formData={formData}
                    selectedMerchant={selectedMerchant}
                    receiverDetails={receiverDetails}
                />
            )}
        </TransactionCommonModal>
    );
};

TransferModal.propTypes = {
    formData: PropTypes.shape({
        currency: PropTypes.shape({
            currencyShortName: PropTypes.string,
        }),
        email: PropTypes.string,
        amount: PropTypes.string,
        reference: PropTypes.string,
    }),
    fieldError: PropTypes.shape({
        currency: PropTypes.string,
        email: PropTypes.string,
        amount: PropTypes.string,
        reference: PropTypes.string,
    }),
    isLoading: PropTypes.bool,
    isConfirmModal: PropTypes.bool,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    handleConfirmationModal: PropTypes.func.isRequired,
    onClickCall: PropTypes.func.isRequired,
    handleAmountChange: PropTypes.func.isRequired,
    handleEmailChange: PropTypes.func.isRequired,
    handleReferenceChange: PropTypes.func.isRequired,
    handleCurrencyChange: PropTypes.func.isRequired,
    balancesCurrencies: PropTypes.array,
    selectedMerchant: PropTypes.object,
    isFormValid: PropTypes.bool,
};

export default TransferModal;
